export function getPioSolverData() {
  if(process.env.NODE_ENV === 'development') {
    return import('../mock/pioSolverData').then((module) => {
      return module.mockData().data;
    });
  }
  return fetch(`${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_pio_data`, {
    method: 'GET'
  })
    .then((res) => {
      if(!res.ok) {
        throw Error('Response error');
      }
      return res.json();
    })
    .then((data) => data.data);
}
